enum RolesType {
  SUPER_ADMIN = "superadmin",
  ADMIN = "admin",
  USER = "user",
}

export default RolesType;
